/* eslint-disable key-spacing,no-inline-comments */
const imports = {
    matchtracker: () => import(/* webpackChunkName: "matchtracker-chunk" */ '../matchtracker'),
    bonuses: () => import(/* webpackChunkName: "chunk-bonusdashboard" */ '../@chunk-bonusdashboard'),
    money: () => import(/* webpackChunkName: "mymoney-chunk" */ '../money'),
    profile: () => import(/* webpackChunkName: "profile-chunk" */ './basechunk/Profile'),
    mytickets: () => import(/* webpackChunkName: "mytickets-chunk" */ '../mytickets/loadable'),
    clubNike: () => import(/* webpackChunkName: "chunk-clubnike" */ '../@chunk-clubnike'),
    offices: () => import(/* webpackChunkName: "chunk-offices" */ '../@chunk-offices'),
    virtualGames: () => import(/* webpackChunkName: "virtualGames-chunk" */ '../virtualgames'),
    betslip: () => import(/* webpackChunkName: "betslip-view-chunk" */ '../betslip/loadable'),
    casinoVegas: () => import(/* webpackChunkName: "casino-vegas-chunk" */ '../casinovegas'),
    casinoSportBookModule: () =>
        import(/* webpackChunkName: "casino-sport-book-mobile-chunk" */ '../casinovegas/views/CasinoSportBookModule'),
    goalOfMonthPage: () => import(/* webpackChunkName: "gom-page-chunk" */ '../goal-of-month/GoalOfMonthPage'),
    notifications: () => import(/* webpackChunkName: "notifications-chunk" */ '../notifications/loadable'),
    selfExclusion: () => import(/* webpackChunkName: "self-exclusion-chunk" */ '../selfExclusion'),
    betbook: () => import(/* webpackChunkName: "betbook-chunk" */ '../betbook'),
    turboLive: () => import(/* webpackChunkName: "turbo-live-chunk" */ '../turbo-live'),
    chat: () => import(/* webpackChunkName: "chat-chunk" */ '../forum/chat'),
    charityCounter: () => import(/* webpackChunkName: "charity-chunk" */ '../charity/views/CharityCounter'),
    tournaments: () => import(/* webpackChunkName: "tournaments-chunk" */ '../tournaments'),
    lotteryTicket: () => import(/* webpackChunkName: "chunk-lottery-ticket" */ '../@chunk-lottery-ticket/index'),
    tvnike: () => import(/* webpackChunkName: "chunk-nike-tv" */ '@/nike-tv/views/NikeTvPage'),
    tvNikeCalendar: () => import(/* webpackChunkName: "TvNikeCalendar" */ '@/nike-tv/views/calendar/NikeTvCalendar'),
    promoCms: () => import(/* webpackChunkName: "promo-cms-chunk" */ '../promo-cms/PromoCmsPage'),
    homepage: () => import(/* webpackChunkName: "chunk.homepage" */ '../homepage/HomepageMobile'),
    articleArchive: () =>
        import(/* webpackChunkName: "chunk.articleArchive" */ '../article-archive/ArticleArchiveMobile')
};

// imports.example = () => import(/* webpackChunkName: "example-chunk" */ '../_example');

export default imports;
